import { Box, Typography, IconButton, Dialog, DialogTitle, DialogContent, Paper, MenuItem, Divider, Grid } from "@mui/material";
import React from "react";
import { WSIcons } from "../../commonFunctions/iIcons";

interface CourseProps {
  open: boolean;
  onClose: () => void;
}

export const Course: React.FC<CourseProps> = ({ open,onClose }) => {
  return (
    <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      style: {
        width: '50rem', // Set your desired width
        height: '30rem', // Set your desired height (if needed)
        backgroundColor:"whitesmoke"
      },
    }}
  >
    <DialogTitle  sx={{backgroundColor:"green"}}>
      <Grid display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" color={"white"}>Select Course</Typography>
        <IconButton onClick={onClose}>
          <WSIcons.CloseIcon sx={{color:"white"}}/>
        </IconButton>
      </Grid>
    </DialogTitle>
    <DialogContent>
    <MenuItem
          sx={{
            backgroundColor: "green",
            justifyContent: "center", // Aligns text in center
            color: "white", // White text color
             mt:2,
            padding:"1rem",
            "&:hover": {
              backgroundColor: "green", // Change color on hover
            },
          }}
          onClick={onClose}
        >
          Main Course
        </MenuItem>
        </DialogContent>
  </Dialog>
  );
};
